export const firebaseConfig = {
    apiKey: "AIzaSyD5bxcY121gkk-b4OOs8l3SFQ4V8246TOU",
    authDomain: "urmeo-45e18.firebaseapp.com",
    databaseURL: "https://urmeo-45e18.firebaseio.com",
    projectId: "urmeo-45e18",
    storageBucket: "urmeo-45e18.appspot.com",
    messagingSenderId: "655973787840"
};



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/environments/firebase.config.ts